import { postJson } from '@psyomics/ui-common';

type VerificationMethod = 'email' | 'phone';

type VerificationStatusResponse = {
  hasPhoneNumber: boolean;
  hasEmail: boolean;
  isAccountVerified: boolean;
};

const fetchVerificationStatus = async (apiUrl: string, signal?: AbortSignal): Promise<VerificationStatusResponse> => {
  const response = await fetch(`${apiUrl}/auth/verification/status`, {
    credentials: 'include',
    method: 'GET',
    signal,
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  const payload = await response.json().catch(() => null);
  if (!payload || typeof payload.isAccountVerified !== 'boolean') {
    throw new Error(`Invalid Verification status response: ${response.status}`);
  }

  return payload;
};

const resendVerificationCode = async (apiUrl: string, method: VerificationMethod): Promise<void> => {
  await postJson(`${apiUrl}/auth/verification/resend`, { method });
};

const confirmVerificationCode = async (apiUrl: string, code: string, method: VerificationMethod): Promise<void> => {
  await postJson(`${apiUrl}/auth/verification/confirm`, { code, method });
};

export { confirmVerificationCode, fetchVerificationStatus, resendVerificationCode };
